export function sanitizeDataTestId(dataTestId: string) {
  const regex = new RegExp(`[ \\._]`, 'g') // space and . and _
  return dataTestId.toLowerCase().replaceAll(regex, '-')
}
